/**
 * A class to make value selection from the user in redux state more clear.
 * @author Akira Kotsugai
 */
export default class UserSelector {
  /**
   * it selects the account dialog's open value
   * @param {Object} state - the redux state
   * @return the action
   */
  static getAccountDialogOpen = state => state.user.ui.accountDialogOpen;

  /**
   * it selects the document dialog's content value
   * @param {Object} state - the redux state
   * @return the action
   */
  static getDocumentDialogContent = state =>
    state.user.ui.documentDialogContent;

  /**
   * it selects the application's decimal separator
   * @param {Object} state - the redux state
   * @return the action
   */
  static getDecimalSeparator = state => state.user.ui.decimalSeparator;

  /**
   * it selects the user in the store
   * @param {Object} state - the redux state
   * @return the action
   */
  static getUser = state => state.user.entities.user;

  static getUserSettings = state => state.user.entities.userSettings;

  static getVersion = state => state.user.entities.version;
}
